import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG, MODAL_md } from '../../../../../../theme/Component/hooks/useModal';
import { _TaxPosition } from '../../../../../../../core/services/dataBean/EntityCatalogVdos';
import { Modal } from '../../../../../../theme/Component/Modal';
import { BasicTable } from '../../../../../../theme/Component/BasicTable';
import usePaginator from '../../../../../../theme/Component/usePaginator';
import { BasicButton } from '../../../../../../theme/Component/BasicButton';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const TaxPositionEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_TaxPosition)
    const [id, setID] = useState(null);
    const paginador = usePaginator();
    const [TaxCode, setTaxCode] = useState<any>(null)
    const [TaxDescription, setTaxDescription] = useState<any>(null)
    const [renderValue,setRenderValue] = useState<string>('');
    const modal = useModal("Porcentaje", MODAL_LG);

    useEffect(() => {
        if(render)
            setRenderValue(render);
    }, [render])
    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        const selectedId = parseInt(e.IDTaxPosition);
        setRenderValue(e.TaxCode +" - "+e.TaxDescription);
        
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDTaxPosition == e.IDTaxPosition
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


      useEffect(() => {
        getLista();
    }, [paginador.page])

  const getLista = () => {

    const filters = {
        ...(TaxCode?.trim() && { 
            TaxCode: `%${TaxCode}%` 
        }),

        ...(TaxDescription?.trim() && { 
            TaxDescription: `%${TaxDescription}%` 
        }),
    };

    instance.getTaxPositionRender(
        paginador.page,
        15,
        filters
    ).then(
        (resp: any) => {
            if (resp) {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                paginador.setRegiPerPage(15);
                setLista(resp.List);
            }
        }
    )
}
    const head = [
        { title: 'ID', property: 'IDTaxPosition', visible: true },
        { title: 'Código Arancel', property: 'TaxCode', visible: true },
        { title: 'Nombre', property: 'TaxDescription', visible: true },
        { title: 'Porcentaje (%)', property: 'TaxPercentage', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Porcentaje Arancel (%)"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{renderValue ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                                                        <label>Código fiscal</label>
                                                        <input type="text" className="form-control" value={TaxCode} onChange={(e) => { setTaxCode(e.target.value) }} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Descripción del impuesto</label>
                                                        <input type="text" className="form-control" value={TaxDescription} onChange={(e) => { setTaxDescription(e.target.value) }} />
                                                    </div>
                                                    <div className="col-md-6 mt-4 p-2">
                                                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                                                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </Modal>
        </>
    )
}